import styled from 'styled-components';

const StyledBanner = styled.div`
  background-color: ${props => props.bgColor};
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  .banner--content{
    width: 66.66%;
  }
  h5{
    padding-bottom: 40px;
    color: #fff;
  }
  a{
    display: flex;
    align-items: center;
  }
  a svg{
    margin-left: 16px; 
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1023px){
    .banner--content{
      width: 83.33%;
    }
    h5{
      padding-bottom: 32px;
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    .banner--content{
      width: 100%;
    }
    h5{
      padding-bottom: 24px;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
`;

export {
  StyledBanner,
};

